import LocalUrlMaker from "../../lib/LocalUrlMaker";
import PropTypes from "prop-types";

export default function CartButtons({cartCode, handleClose}) {
  let cartUrl = LocalUrlMaker.prefixedPath(`/cart/${cartCode}`);

  const handleViewCart = () => {
    handleClose({label: 'view_cart_button'});
    window.location = cartUrl;
  }

  return <div className="py-4 grid grid-rows-2 lg:grid-cols-3 gap-4 lg:gap-8">
    <div>
      <a className="btn-primary py-2 w-full "
        onClick={handleViewCart}
        href={cartUrl}>View Cart</a>
    </div>
    <div>
      <a className="btn-outline-dark py-2 w-full "
        onClick={handleClose}>Keep Shopping</a>
    </div>
  </div>
}

CartButtons.propTypes = {
  handleClose: PropTypes.func.isRequired
}
